import { render } from "./ButtonLoading.vue?vue&type=template&id=6b52f01e&scoped=true"
import script from "./ButtonLoading.vue?vue&type=script&lang=js"
export * from "./ButtonLoading.vue?vue&type=script&lang=js"

import "./ButtonLoading.vue?vue&type=style&index=0&id=6b52f01e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b52f01e"]])

export default __exports__